import { Injectable } from "@angular/core";
import { UserService } from "./user.service";
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { UserAction } from './action-types';
import { catchError, map, switchMap, tap, of } from "rxjs";
import { MatDialog } from "@angular/material/dialog";
import { UserLoadedFailDialogComponent } from "./components/dialogs/user-loaded-fail-dialog/user-loaded-fail-dialog.component";
import { Store } from "@ngrx/store";

@Injectable()
export class UserEffects {

    readonly loadUser$ = createEffect(() =>
        this.actions$.pipe(
            ofType(UserAction.loadUser),
            switchMap(() =>
                this.userService.loadUser().pipe(
                    map(profile => UserAction.userLoaded({ profile })),
                    catchError(error => of(UserAction.userLoadFailed({ error })))
                )
            )
        )
    )

    readonly loadUserFail$ = createEffect(() =>
        this.actions$.pipe(
            ofType(UserAction.userLoadFailed),
            tap((action) => this.matDialog.open(UserLoadedFailDialogComponent, { data: action.error.message }))
        ),
        { dispatch: false }
    )

    constructor(
        private readonly store: Store,
        private readonly actions$: Actions,
        private readonly userService: UserService,
        private readonly matDialog: MatDialog
    ) { }

}